import axios from 'axios'

export default {
  getLog(type, numb) {
    return axios.get(`/api/admins/logs/${type}/${numb}`)
  },
  getStudentsChangeLog(filters, currentPage, pageSize) {
    const query = {
      params: {
        pageNumber: currentPage,
        perPage: pageSize,
        filters
      }
    }
    return axios.get('/api/admins/logs/students', query)
  },
  getActivityLogs(filters, currentPage, pageSize) {
    const query = {
      params: {
        pageNumber: currentPage,
        perPage: pageSize,
        filters
      }
    }
    return axios.get('/api/admins/logs/activity', query)
  }
}
